import useSWR from "swr";

export interface Event {
  id: string;
  name: string;
  welcome_message: string | null;
  logo_url: string | null;
  is_current: boolean;
}

interface EventData {
  event: Event | null;
}

async function fetcher(url: string) {
  const res = await fetch(url);
  if (!res.ok) throw new Error(`Event fetch failed (${res.status})`);
  return res.json();
}

export function useEvent() {
  const { data, error, isLoading, mutate } = useSWR<EventData>(
    "/api/event",
    fetcher,
    { shouldRetryOnError: false },
  );

  return {
    event: data?.event ?? null,
    isLoading,
    error,
    mutate,
  };
}
